exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no_car_list .no_car_icon[data-v-31a210a2]{display:block;margin:0 auto;padding:3.33333333rem 0 .66666667rem;width:2.33333333rem;height:2.33333333rem}.no_car_list .tips[data-v-31a210a2]{text-align:center;color:#000;opacity:.4;font-size:.4rem}", ""]);

// exports
